/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VisualizzazioneTipoPratica } from './visualizzazione-tipo-pratica';
import { GraduatoriaDTO } from './graduatoria-dto';
import { PolicyDTO } from './policy-dto';
import { TipoPraticaStato } from './tipo-pratica-stato';
import { AzioneStatoDTO } from './azione-stato-dto';
import { TipologiaPratica } from './tipologia-pratica';


export interface TipoPraticaDTO { 
    id?: string;
    comune_id?: string;
    comune_slug?: string;
    codice?: string;
    tipologia?: TipologiaPratica;
    stato?: TipoPraticaStato;
    visualizzazione?: VisualizzazioneTipoPratica;
    titolo?: string;
    descrizione?: string;
    data_apertura?: string;
    data_chiusura?: string;
    data_pubblicazione_graduatoria?: string;
    data_riferimento_avviso?: string;
    url_documentazione?: string;
    configurazione_form_cittadino?: any | null;
    configurazione_form_esercente?: any | null;
    ultimo_errore_schedulazione?: string;
    ultimo_errore_schedulazione_at?: string;
    stato_prima_archiviazione?: TipoPraticaStato;
    version?: number;
    created_at?: string;
    updated_at?: string;
    policy?: PolicyDTO;
    graduatoria?: GraduatoriaDTO;
    azioni_stato?: Array<AzioneStatoDTO>;
}



